// ── Native Google Sign-In (Android) ──────────────────────────────────────────
// Firebase's signInWithPopup/signInWithRedirect are web-only — Google blocks
// them inside any embedded WebView (which is what a Capacitor app's WebView
// looks like to Google). On native we instead use the phone's own Google
// account picker via @capgo/capacitor-social-login, then hand its ID token to
// Firebase via signInWithCredential — same end result, different transport.
//
// Requires an Android app registered in the Firebase project (package
// com.clarity.app) with its SHA-1 signing fingerprint added — see Firebase
// Console → Project Settings → Your apps → Android app → SHA certificate
// fingerprints. Without that, native sign-in fails even with correct code.
import { SocialLogin } from '@capgo/capacitor-social-login';

const WEB_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

let initPromise = null;
function ensureInitialized() {
  if (!initPromise) {
    initPromise = SocialLogin.initialize({ google: { webClientId: WEB_CLIENT_ID } });
  }
  return initPromise;
}

// Returns a Google ID token (JWT) the caller hands to Firebase's
// GoogleAuthProvider.credential(). Throws SocialLoginError with
// code === 'USER_CANCELLED' if the user backs out of the picker.
export async function nativeGoogleIdToken() {
  await ensureInitialized();
  // No explicit `scopes` here — the plugin already requests email/profile/openid
  // by default, and passing scopes ourselves would require modifying MainActivity
  // to implement ModifiedMainActivityForSocialLoginPlugin (unnecessary extra work).
  const { result } = await SocialLogin.login({
    provider: 'google',
    options: {},
  });
  if (result.responseType !== 'online' || !result.idToken) {
    throw new Error('Google sign-in did not return an ID token');
  }
  return result.idToken;
}
